import JurisdictionService from './micro-services/jurisdiction';
import RegulatorsService from './micro-services/regulators';
import DocumentTypesService from './micro-services/documentTypes';
import ColleaguesService from './micro-services/colleagues';
import WFColleaguesService from './micro-services/wfColleagues';
import ServiceLinesService from './micro-services/serviceLines';
import RegCatsService from './micro-services/regCats';
import ThemesService from './micro-services/themes';
import SavedSearchService from './micro-services/savedSearch';
import PersonalTagsService from './micro-services/personalTags';
import TaxonomyService from './micro-services/taxonomy';
import DashboardService from './micro-services/dashboards';
import ClientTaxonomiesService from './micro-services/client-taxonomies';
import UserGroupsService from './micro-services/userGroups';
// import RiskFusionService from './micro-services/riskFusion';
import DataHelper from '../../helpers/DataHelper';
// import store from 'store';


class CacheService {
    constructor() {
    }

    init() {
        TaxonomyService.init();
        TaxonomyService.getTaxonomy();
        DashboardService.getDashboards();
        this.canGet = true;
        this.DH = new DataHelper();
        this.reloads = {
            savedSearches: SavedSearchService,
            personalTags: PersonalTagsService,
            colleagues: ColleaguesService,
            taxonomy: TaxonomyService,
            regulators: RegulatorsService,
            wfColleagues: WFColleaguesService,
            themes: ThemesService,
            dashboards: DashboardService,
            clientTaxonomies: ClientTaxonomiesService,
            userGroups: UserGroupsService
        }
    }

    resetCache(model) {
        this.reloads[model].resetCache();
    }

    sortData(data, key) {
        data = data.sort((a, b) => {
            if (a[key] > b[key]) return 1;
            else if (a[key] < b[key]) return -1;
            else return 0;
        });
        return data;
    }

    data() {
        return new Promise((resolve, reject) => {
            var searchInterval = setInterval(() => {
                if (this.canGet) {
                    this.promiseFactory().then((resp) => {
                        clearInterval(searchInterval);
                        resolve(resp)
                    })
                }
            }, 50)
        })
    }

    promiseFactory() {
        this.canGet = false
        const dataObject = {};

        return new Promise((resolve, reject) => {
            Promise.all([
                JurisdictionService.getJurisdiction(),
                RegulatorsService.getRegulators(),
                DocumentTypesService.getDocumentTypes(),
                ColleaguesService.getColleagues(),
                //ServiceLinesService.getServiceLines(true), // Flat list     
                ServiceLinesService.getServiceLines(false), // Full tree list 
                RegCatsService.getRegCats(),
                SavedSearchService.getSavedSearches(),
                PersonalTagsService.getPersonalTags(),
                //RiskFusionService.getRiskFusionServices(),
                WFColleaguesService.getColleagues(),
                ThemesService.getThemes(),
                DashboardService.getDashboards(),
                ClientTaxonomiesService.getClientTaxonomies(),
                UserGroupsService.getUserGroups()
            ]).then(resp => {
                dataObject.jurisdictions = resp[0];
                dataObject.regulators = this.sortData(resp[1].regulators, 'label');
                dataObject.documentTypes = resp[2].documentTypes.categories;
                dataObject.documentTypesTree = resp[2].documentTypesTree;
                dataObject.colleagues = resp[3].usernames;
                //dataObject.serviceLinesFlat = resp[4].ServiceLines;
                dataObject.serviceLinesTree = this.DH.prepareNestedComboObj(JSON.parse(JSON.stringify(resp[4])));
                dataObject.regCategories = this.DH.prepareNestedComboObj(JSON.parse(JSON.stringify(resp[5])));
                dataObject.savedSearches = resp[6].saved_searches;
                dataObject.personalTags = resp[7].tags.map(item => ({ label: item, value: item }));

                dataObject.riskFusion = {
                    Categories: this.DH.prepareNestedComboObj(JSON.parse(JSON.stringify(resp[5])), 'rf_id'),
                    ServiceLines: this.DH.prepareNestedComboObj(JSON.parse(JSON.stringify(resp[4])), 'rf_id')
                }
                dataObject.wfColleagues = resp[8].usernames;
                dataObject.themes = this.DH.prepareNestedComboObj(JSON.parse(JSON.stringify(resp[9].themes)));
                dataObject.flatThemes = resp[9].flatThemes;
                dataObject.dashboards = resp[10].dashboards;
                dataObject.clientTaxonomies = resp[11].clientTaxonomies;
                dataObject.flatTaxonomies = resp[11].flatTaxonomies;
                dataObject.userGroups = resp[12].groups;
                this.canGet = true;
                resolve(dataObject);
            });
        });
    }
}

export default new CacheService();


// WEBPACK FOOTER //
// ./src/services/Cache/CacheService.js